import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import Tooltip from "./../utils/Tooltip";

// State
import { updateCartQty, clearUpdateMsg } from "../../store/actions/cart";
import { revertCheckoutAfterCartChanged } from "../../store/actions/checkout";

// CSS
import "../../css/button.css";

class UpdateQtyCell extends Component {
	constructor(props) {
		super(props);
		this.state = {
			qty: this.props.product.qty
		};
	}

	componentWillMount() {
		this.props.clearUpdateMsg();
	}

	handleInputChange(event) {
		// Ensure value is greater than 0 and an integer
		const value =
			event.target.value === "" || +event.target.value < 1 ? "" : +event.target.value;

		// Set new qty for input
		this.setState({
			qty: value
		});
	}

	handleKeyPress(event, item_id) {
		if (event.key === "Enter") {
			if (this.shouldShowError() || this.shouldShowSuccess()) {
				this.props.clearUpdateMsg();
			} else {
				this.handleUpdateQty(item_id, this.state.qty);
			}
		}
	}

	handleUpdateQty(cartItemId, qty) {
		this.props
			.updateCartQty(cartItemId, qty)
			.then(() => this.props.revertCheckoutAfterCartChanged());
	}

	shouldShowError() {
		return (
			this.props.updateError !== undefined && this.props.product.id === this.props.updatedId
		);
	}

	shouldShowSuccess() {
		return (
			this.props.updateSuccess !== undefined && this.props.product.id === this.props.updatedId
		);
	}

	render() {
		const showErrorTooltip = this.shouldShowError();
		const showSuccessTooltip = this.shouldShowSuccess();

		const loading =
			this.props.updateInProcess && this.props.product.id === this.props.updatedId;

		// Set up button classes
		let classes = "btn";
		if (this.state.qty === this.props.product.qty) classes += " hidden_element";
		if (loading) classes += " loading";

		return (
			<div>
				<input
					className="qty"
					ref={tooltipParentName => (this.tooltipParentName = tooltipParentName)}
					type="number"
					min="1"
					step="1"
					name="qty"
					placeholder="0"
					value={this.state.qty}
					onKeyPress={e => this.handleKeyPress(e, this.props.product.id)}
					onChange={event => this.handleInputChange(event)}
				/>
				<div className="btn_container">
					<button
						className={classes}
						name="update"
						onClick={() => this.handleUpdateQty(this.props.product.id, this.state.qty)}
						disabled={loading}
					>
						<span>Update</span>
					</button>
					{showErrorTooltip && this.tooltipParentName && (
						<Tooltip
							parent={this.tooltipParentName}
							type={"dialog--error"}
							messageObjects={this.props.updateError}
							closeAction={this.props.clearUpdateMsg}
						/>
					)}
					{showSuccessTooltip && this.tooltipParentName && (
						<Tooltip
							parent={this.tooltipParentName}
							type={"dialog--success"}
							messageObjects={{ success: this.props.updateSuccess }}
							closeAction={this.props.clearUpdateMsg}
						/>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		updateSuccess: state.cart.updateSuccess,
		updateError: state.cart.updateError,
		updatedId: state.cart.updatedId,
		updateInProcess: state.cart.updateInProcess
	};
};

export default connect(
	mapStateToProps,
	{ updateCartQty, revertCheckoutAfterCartChanged, clearUpdateMsg }
)(UpdateQtyCell);



// WEBPACK FOOTER //
// ./src/components/cart/UpdateQtyCell.js